export default {
  getAccessToken() {
    return localStorage.getItem('wak_access_token') || null
  },

  getBaseApiUrl() {
    return process.env.VUE_APP_BASE_API_URL || 'http://localhost/api'
  }
}
